import { useEffect } from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { stepperData } from "../constant/appConstant";
import CustomerJourney from "../pages/CustomerJourney";
import { setStepData } from "../redux/slices/customerJourney";
import { useAppDispatch } from "../redux/store";
import DefaultLayout from "../layout";
import AppliedSuccessfull from "../components/feature/StepManager/AppliedSuccessfull";

const AppRouter = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();

  const redirectHome = () => {
    sessionStorage.clear();
    dispatch(setStepData({ data: stepperData[0] }));
    sessionStorage.setItem("currentStep", JSON.stringify(stepperData[0]));
    navigate("/rex-cj");
    navigate(0);
  };

  useEffect(() => {
    if (location.pathname === "/") {
      redirectHome();
    }
  }, []);

  useEffect(() => {
    const handleBrowserBack = () => {
      redirectHome();
    };
    window.addEventListener("popstate", handleBrowserBack);
    return () => {
      window.removeEventListener("popstate", handleBrowserBack);
    };
  }, []);

  return (
    <Routes>
      <Route key="location" path="/rex-cj" element={<CustomerJourney />} />
      <Route
        key="location"
        path="/rex-cj/candidateRegistered"
        element={
          <DefaultLayout>
            <AppliedSuccessfull />
          </DefaultLayout>
        }
      />
      <Route path="*" element={<Navigate to="/rex-cj" replace={true} />} />
      {/* <Route
        key="examDetails"
        element={<CustomerJourney />}
        path="/examDetails"
      />
      <Route
        key="termsAndConditions"
        element={<CustomerJourney />}
        path="/termsAndConditions"
      />
      <Route
        key="candidateData"
        element={<CustomerJourney />}
        path="/candidateData"
      />
      <Route
        key="confirmation"
        element={<CustomerJourney />}
        path="/confirmation"
      /> */}
    </Routes>
  );
};

export default AppRouter;
